// App.js
import React, { useEffect, useState } from 'react';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import axios from 'axios';
import { useSelector } from 'react-redux';

import { FilesContext } from './Contexts/filesContext';
import { WebSocketProvider, useWebSocket } from './WebSocketContext';

import Router from './Routes/MainRoutes';
import MainThemeProvider from './theme';
import ScrollToTop from './components/ScrollToTop';
import NotificationToast from './NotificationToast'; // تأكد أن المسار صحيح

import 'bootstrap/dist/css/bootstrap.min.css';

function AppContent({ searchInput, setSearchInput, userData, userInfo }) {
  // استهلاك الإشعارات من الـ Context
  const { notifications } = useWebSocket() || {};
  const latestNotification = notifications?.[0]; // آخر إشعار وصل

  return (
    <FilesContext.Provider value={{ searchInput, setSearchInput }}>
      <StyledEngineProvider injectFirst>
        <CssBaseline />
        <MainThemeProvider>
          <ScrollToTop />

          {/* Router */}
          <Router />

          {/* Toast يظهر عند وصول إشعار جديد */}
          <NotificationToast notification={latestNotification} />
        </MainThemeProvider>
      </StyledEngineProvider>
    </FilesContext.Provider>
  );
}

export default function App() {
  const [searchInput, setSearchInput] = useState('');
  const [userData, setUserData] = useState(null);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  // إعداد الـ headers
  const config = {
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${userInfo?.access}`,
    },
  };

  // دالة تجيب بيانات المستخدم
  const getUserData = async () => {
    if (userInfo) {
      const response = await axios.get(
        `${process.env.REACT_APP_API_KEY}/api/v1/accounts/user-details/${userInfo.id}`,
        config
      );
      setUserData(response.data);
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <WebSocketProvider email={userData?.email} token={userInfo?.access}>
      <AppContent
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        userData={userData}
        userInfo={userInfo}
      />
    </WebSocketProvider>
  );
}
